<div class="tile-padding-first tile-padding">
  <ng-template #utilityBarForm>
    <div>
      @if (errorMsg.length > 0) {
        <label class="tw:text-danger">{{errorMsg}}</label>
      }
      <form [formGroup]="frmSubmissionSearch">
        <div class="flex-search-container tw:pb-4" [class.filter-bar]="filtersEnabled">
          <div fxLayout="column" fxLayout.gt-md="row" fxLayoutWrap fxLayoutGap="1%" class="flex-search-sub filter-bar__group">
            <div fxLayout.gt-md="column" class="filter-bar__field">
              <div>
                <label class="field__label">Client Referrer</label>
                <app-typeahead inputClass="field__control body-content" placeholder="Client Referrer" formControlName="clientReferrer"
                  data-toggle="tooltip" data-placement="top" title="Please enter the client referrer"
                  [enabled]="autocompleteEnabled" [source]="suggest.referrers" [displayWith]="suggest.name"></app-typeahead>
              </div>
              </div>
              <div fxLayout.gt-md="column" class="filter-bar__field">
                <div>
                  <label class="field__label">Client</label>
                  <app-typeahead inputClass="field__control body-content" placeholder="Client" formControlName="client"
                    data-toggle="tooltip" data-placement="top" title="Please enter the client name"
                    [enabled]="autocompleteEnabled" [source]="clientSuggestions.search" [prefetch]="clientSuggestions.prefetch" [displayWith]="clientSuggestions.display" [valueWith]="clientSuggestions.value"></app-typeahead>
                </div>
                </div>
                <div fxLayout.gt-md="column" class="filter-bar__field">
                  <div>
                    <label class="field__label">Tutor</label>
                    <app-typeahead inputClass="field__control body-content" placeholder="Tutor" formControlName="tutor"
                      data-toggle="tooltip" data-placement="top" title="Please enter the tutor name"
                      [enabled]="autocompleteEnabled" [source]="suggest.tutors" [displayWith]="suggest.name"></app-typeahead>
                  </div>
                  </div>
                  <div fxLayout.gt-md="column" class="filter-bar__field">
                    <crm-user-select></crm-user-select>
                  </div>
                  <div fxLayout.gt-md="column" class="filter-bar__group" *appFeatureSwitch="featureKeys.filtersMissingSubmissions">
                    <app-brand-filter class="filter-bar__field" [companyIds]="companyIds"
                      (companyIdsChange)="companyIds = $event"></app-brand-filter>
                  </div>
                </div>
                <div fxLayout="column" fxLayout.gt-md="row" fxLayoutWrap fxLayoutGap="1%" class="flex-search-sub filter-bar__group"
                  *appFeatureSwitch="featureKeys.filtersMissingSubmissions" id="missingSubmissionFilters">
                  <div fxLayout.gt-md="column" class="filter-bar__field">
                    <label class="field__label">Missing item</label>
                    <app-searchable-select multiple [items]="missingItemTypeOptions" displayField="label" valueField="value"
                      placeholder="Any missing item" searchPlaceholder="Search…"
                      [ngModel]="missingItemTypes" [ngModelOptions]="{ standalone: true }"
                      (selectionChange)="missingItemTypes = $event"></app-searchable-select>
                  </div>
                  <div fxLayout.gt-md="column" class="filter-bar__field">
                    <label class="field__label" for="daysOverdueFilter">Days overdue</label>
                    <select id="daysOverdueFilter" class="field__control" [ngModel]="daysOverdue" [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="daysOverdue = $event">
                      <option [ngValue]="null">Any</option>
                      @for (option of daysOverdueOptions; track option.value) {
                        <option [ngValue]="option.value">{{option.label}}</option>
                      }
                    </select>
                  </div>
                  <div fxLayout.gt-md="column" class="filter-bar__field">
                    <label class="field__label">Consultant</label>
                    <app-searchable-select multiple [items]="consultants" displayField="userFullName" valueField="id"
                      placeholder="All consultants" searchPlaceholder="Search consultants…"
                      [ngModel]="consultantIds" [ngModelOptions]="{ standalone: true }"
                      (selectionChange)="consultantIds = $event"></app-searchable-select>
                  </div>
                </div>
                <div fxLayout="column" fxLayout.gt-md="row" fxLayoutWrap fxLayoutGap="1%" class="flex-search-sub filter-bar__group">
                  <div fxLayout.gt-md="column" class="filter-bar__field">
                    <div>
                      <label class="field__label">Date From</label>
                      <input type="date" class="field__control" formControlName="startDate" required (input)="datePreset = null"
                        [max]="maxDate"
                        data-toggle="tooltip" data-placement="top" title="Please enter the from date">
                      @if (frmSubmissionSearch.controls.startDate.invalid && frmSubmissionSearch.controls.startDate.touched) {
                        <span class="field__error">Enter Date From</span>
                      }
                      </div>
                    </div>
                    <div fxLayout.gt-md="column" class="filter-bar__field">
                      <div>
                        <label class="field__label">Date To</label>
                        <input type="date" class="field__control" formControlName="endDate" required (input)="datePreset = null"
                          [max]="maxDate"
                          data-toggle="tooltip" data-placement="top" title="Please enter the to date">
                        @if (frmSubmissionSearch.controls.endDate.invalid && frmSubmissionSearch.controls.endDate.touched) {
                          <span class="field__error">Enter Date To</span>
                        }
                        </div>
                      </div>
                      @if (!filtersEnabled) {
                        <div fxLayout.gt-md="column">
                          <div><label class="field__label tw:invisible">&nbsp;</label></div>
                          <button class="btn-outline-primary btn" style="height: 38px;" name="Search" value="Search" (click)="searchSubmission()">Search</button>
                        </div>
                      }
                    </div>
                    @if (filtersEnabled) {
                      <div class="filter-bar__actions">
                        <div class="filter-bar__presets">
                          <app-date-presets [selected]="datePreset" (presetSelected)="onDatePreset($event)"></app-date-presets>
                        </div>
                        <div class="filter-bar__buttons">
                          <app-filter-clear-all (clear)="clearAll()"></app-filter-clear-all>
                          <button class="btn btn-primary" name="Search" value="Search" (click)="searchSubmission()">Search</button>
                        </div>
                      </div>
                    }
                  </div>
                </form>
              </div>
            </ng-template>
          </div>
          <div>
            <missing-submissions [submissionParams]="submissionParams" [displayall]="false" [currDate]="currDate" class="grid-secondary" pageheader="" *checkFeatureRender="'MissingSubmissionsView'"></missing-submissions></div>
